<div class="title" fxLayout="row" fxLayoutAlign="space-between end">
  <h1>{{'エントリー情報' | translate}}</h1>

  <div class="basic-button" fxLayoutGap="10px">
    <button mat-raised-button color="primary" (click)="openSearch()" [disabled]="false">
      <mat-icon>search</mat-icon>
      <span>{{'条件' | translate}}</span>
    </button>

    <button mat-raised-button color="warn" (click)="deleteData()" [disabled]="!selection.selected.length">
      <mat-icon>delete</mat-icon>
      <span>{{'削除' | translate}}</span>
    </button>
  </div>
</div>

<div class="filter-field" fxLayout="row" fxLayoutGap="20px">
  <mat-form-field fxFlex="25%">
    <mat-label>Filter</mat-label>
    <input matInput (keyup)="applyFilter($event)" autocomplete="off" #input>
  </mat-form-field>
</div>

<div fxLayout="column" fxLayoutAlign="center center" [formGroup]="editForm">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z8" matSort (matSortChange)="sortData($event)">

    <ng-container matColumnDef="position">
      <th mat-header-cell *matHeaderCellDef> No. </th>
      <td mat-cell *matCellDef="let entry; let i = index"> {{searchParameter.index == 0 ?  i + 1 : i + 1 + searchParameter.index * searchParameter.limit }} </td>
    </ng-container>

    <ng-container matColumnDef="edit">
      <th mat-header-cell  *matHeaderCellDef> {{'編集' | translate}} </th>
      <td mat-cell *matCellDef="let entry">
        <button mat-button color="primary" (click)="openEditDialog(entry)">
          <mat-icon>create</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef> {{'削除' | translate}} </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          color="warn"
          (click)="$event.stopPropagation()"
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          [aria-label]="checkboxLabel(row)">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="event_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'イベント' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> 
        {{ getEventName(entry) }}
      </td>
    </ng-container>

    <!-- <ng-container matColumnDef="open_period">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'開催期間' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> 
        {{ getOpenPeriod(entry) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="entry_period">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'募集期間' | translate}} </th>
      <td mat-cell *matCellDef="let entry">
        {{ getEntryPeriod(entry) }}
      </td>
    </ng-container> -->

    <ng-container matColumnDef="entry_no">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'エントリー番号' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> {{ entry.entry_no }} </td>
    </ng-container>

    <ng-container matColumnDef="company_name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'会社名' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> {{ entry.company_name }} </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'登録者' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> {{ entry.family_name }}&nbsp;&nbsp;{{ entry.first_name }} </td>
    </ng-container>

    <ng-container matColumnDef="email_address">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'メールアドレス' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> {{ entry.email_address }} </td>
    </ng-container>

    <ng-container matColumnDef="mail_send_status">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'メール送信状況' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> {{ entry.mail_send_status | mailSendStatus }}</td>
    </ng-container>

    <ng-container matColumnDef="preview">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'環境' | translate}} </th>
      <td mat-cell *matCellDef="let entry"> {{ entry.preview | preview }}</td>
    </ng-container>

    <ng-container matColumnDef="transit">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'入退場状況' | translate}} </th>
      <td mat-cell *matCellDef="let entry">
        <button mat-button color="primary" (click)="openTransitDialog(entry)">
          <mat-icon>sync_alt</mat-icon>
        </button>
      </td>
    </ng-container>

    <ng-container matColumnDef="created">
      <th mat-header-cell mat-sort-header *matHeaderCellDef> {{'登録日時' | translate}} </th>
      <td mat-cell *matCellDef="let entry"><span *ngIf="entry.created"> {{ entry.created.toDate() | date: 'yyyy/MM/dd HH:mm:ss' }} </span></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>

  <div fxFlex="67px">
    <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
      <div fxFlex='2px' style="background: #3F51B5;"></div>
      <div fxLayout="row" fxFlexFill fxLayoutAlign="end center">
        <div fxFlex>
          <div fxLayout="column" fxFlexFill fxLayoutAlign="start end" style="font-size: 12px; color: rgba(0,0,0,.54);">
            Items per page:
          </div>
        </div>
        <div fxFlex="10px"></div>
        <div fxFlex="56px" [style.fontSize.px]="12">
          <div fxLayout="column" fxFlexFill fxLayoutAlign="start stretch">
            <mat-form-field style="width: 75px;" appearance="outline" fxFlex>
              <mat-select formControlName="pagesize" (selectionChange)="onPageSizeChange($event)" [disabled]="!!isProcessing">
                <mat-option value=15>15</mat-option>
                <mat-option value=50>50</mat-option>
                <mat-option value=100>100</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div fxFlex="50px"></div>
        <div fxFlex="40px">
          <button mat-icon-button (click)="onPrevClick()" [disabled]="searchParameter.index === 0 || !searchParameter.prev_doc || !!isProcessing"><mat-icon>keyboard_arrow_left</mat-icon></button>
        </div>
        <div fxFlex="40px">
          <button mat-icon-button (click)="onNextClick()" [disabled]="!searchParameter.next_doc || !!isProcessing"><mat-icon>keyboard_arrow_right</mat-icon></button>
        </div>
        <div fxFlex="10px"></div>
      </div>
    </div>
  </div>


</div>
